export default __webpack_public_path__ + "static/media/about_banner2.2945776c.png";